interface State {
  ageRadio1: number
  ageRadio2: number
  allFukens: boolean
  fukenCheckes: any[]
  jobRadio: number
  typeRadio: number
  charmRadio: number
  shutubotuRadio: number
  sortRadio: number
  isLoginWith24Hours: number
  isNewFace: number
  isProfImage: number
  jobs: {}
  types: {}
  charms: {}
}

const defaultState: State = {
  ageRadio1: 0,
  ageRadio2: 0,
  allFukens: true,
  fukenCheckes: [],
  jobRadio: 0,
  typeRadio: 0,
  charmRadio: 0,
  shutubotuRadio: 0,
  sortRadio: 0,
  isLoginWith24Hours: 0,
  isNewFace: 0,
  isProfImage: 0,
  jobs: {},
  types: {},
  charms: {}
}

const state: State = Object.assign({}, defaultState)

const mutations = {
  resetState(state: State) {
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  setAgeRadio1(state: State, ageRadio1: number) {
    state.ageRadio1 = ageRadio1
  },
  setAgeRadio2(state: State, ageRadio2: number) {
    state.ageRadio2 = ageRadio2
  },
  setAllFukens(state: State, allFukens: boolean) {
    state.allFukens = allFukens
  },
  clearFukenCheckes(state: State) {
    state.fukenCheckes = []
  },
  setFukenCheckValue(state: State, checkValue: number) {
    if (state.fukenCheckes.includes(checkValue)) {
      return
    }
    state.fukenCheckes.push(checkValue)
  },
  setJobRadio(state: State, value: number) {
    state.jobRadio = value
  },
  setTypeRadio(state: State, value: number) {
    state.typeRadio = value
  },
  setCharmRadio(state: State, value: number) {
    state.charmRadio = value
  },
  setShutubotuRadio(state: State, value: number) {
    state.shutubotuRadio = value
  },
  setSortRadio(state: State, sortRadio: number) {
    state.sortRadio = sortRadio
  },
  setIsLoginWith24Hours(state: State, isLoginWith24Hours: number) {
    state.isLoginWith24Hours = isLoginWith24Hours
  },
  setIsNewFace(state: State, isNewFace: number) {
    state.isNewFace = isNewFace
  },
  setIsProfImage(state: State, isProfImage: number) {
    state.isProfImage = isProfImage
  },
  setJobs(state: State, jobs: {}) {
    state.jobs = jobs
  },
  setTypes(state: State, types: {}) {
    state.types = types
  },
  setCharms(state: State, charms: {}) {
    state.charms = charms
  }
}

const actions = {}

const getters = {
  ageRadio1: (state: State): number => state.ageRadio1,
  ageRadio2: (state: State): number => state.ageRadio2,
  allFukens: (state: State): boolean => state.allFukens,
  fukenCheckes: (state: State): any[] => state.fukenCheckes,
  jobRadio: (state: State): number => state.jobRadio,
  typeRadio: (state: State): number => state.typeRadio,
  charmRadio: (state: State): number => state.charmRadio,
  shutubotuRadio: (state: State): number => state.shutubotuRadio,
  sortRadio: (state: State): number => state.sortRadio,
  isLoginWith24Hours: (state: State): number => state.isLoginWith24Hours,
  isNewFace: (state: State): number => state.isNewFace,
  isProfImage: (state: State): number => state.isProfImage,
  jobs: (state: State): {} => state.jobs,
  types: (state: State): {} => state.types,
  charms: (state: State): {} => state.charms
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
